// -*- Mode: rjsx -*-
import React from 'react';
import axios from 'axios';

import { Spinner } from '../ui/Spinner';
import Morty from '../data/Morty';

// Takes an HTML string and replaces all tags 
// Can specify certain tags to keep with a 
// comma seperated string eg. "a,img,p"
function local_sanitizeHtml(htmlString, allowedTags) {
    
    var $s = $('<div>' + htmlString + '</div>');
    var $elements = $s.find("*"); // .not(_allowedTags);
    for (var i = $elements.length - 1; i >= 0; i--) {
        var e = $elements[i];
        if(e.style.position) {
            e.style.position = 'relative';
        }
        
        if(e.tagName.toLowerCase() === 'style') {
            $(e).replaceWith($('<!-- style -->'));
        }
        else if(e.tagName.toLowerCase() === 'meta') {
            $(e).replaceWith($('<!-- meta -->'));
        }
        
    }

    
    return $s.html();
}



class NoteHeader extends React.Component {

    render() {
        let note = this.props.note;
        let leftSide = null;
        if(note.type === 'message-from-mentor')
            leftSide = <strong>Message from Mentor</strong>;
        let sentBy = note.user ? note.user.display_name : (note.sender ? note.sender : '');
        let date = new Date(note.date_created + "Z").format('m/d "at" h:MM TT');
        let rightSide = (
            <div>
       	      <span><i className="fh-icon-email" style={style.icon}></i> Sent by <strong>{sentBy}</strong></span>
              <span> <span>&nbsp;</span> <i className="fh-icon-calendar" style={style.icon}></i> {date}</span>
            </div>
        );
        return (
            <div className="request-message--header cf">
       	      <div className="left"> { leftSide } </div>
       	      <div className="right"> { rightSide } </div>              
            </div>
        );
    }
}
class NoteContentFromSystem extends React.Component {
    render() {
        let note = this.props.note;
        if(note.date_created.indexOf('.') !== -1)
            note.date_created = note.date_created.substring(0, note.date_created.indexOf('.'));

        let d = new Date(note.date_created + "Z").format('m/d "at" h:MM TT');
            //     		<a class="show-message" href="javascript://" onclick="$('#message_<%=message.key%>').toggle()">Show response</a>	
            //     		<div class="request-message--message-content hidden" id="message_<%=message.key%>">
            //     			<%= message.content %>
            // </div>
        let toggle = null;
        let subject = null;
        if(note.subject) {
            toggle = <a className="show-message" href="javascript://" onClick={() => $("#note-" + note.key).toggle()}>Show response</a>;
            subject = <div key={'subject-' + note.key }>Subject: <strong>{ note.subject }</strong></div>;
        }


        return (
            <div className="request-message--body">
              { subject }
              <span className="right"> <i className="fh-icon-calendar" style={style.icon}></i> { d }</span>
              { toggle }
              <div id={"note-" + note.key} className={(note.subject ? "request-message--message-content hidden" : "request-message--message-content")}dangerouslySetInnerHTML={{__html: note.content}}></div>
            </div>
        );
        
    }
}

function cleanHtml(message) {
    if(message.content == null) {
        return "(This message has no content)";
    }
    if(message.content_type === "text/plain") {
        return showLineBreaks(message.content);
    }
    let content = message.content;
    if(true || (message.type === "message-from-third-party")) {
        // message.full_email_content = message.content;
        try {
            content = local_sanitizeHtml(message.content);
        } catch(err) {
            console.error(err);
            console.log("ERROR SANITIZING HTML");
            content = strip(message.content);
        }
    } else if( message.type !== "message-from-system" && message.content) {
        content = showLineBreaks(message.content);
    }
    return content;
}

class NoteContent extends React.Component {

    
    
    render() {
        let note = this.props.note;

        if(note.type === 'message-from-system') {
            return <NoteContentFromSystem note={note} />;
        }
        let metaData = [];
        if(note.subject) 
	    metaData.push(<div key={'subject-' + note.key }>Subject: <strong>{ note.subject }</strong></div>);
        if(note.original_to) 
	    metaData.push(<div key={'to-' + note.key }>To: <strong>{ note.original_to }</strong></div>);
        if(note.original_cc) 
	    metaData.push(<div key={'cc-' + note.key }>CC: <strong>{ note.original_cc }</strong></div>);

        let content = <div dangerouslySetInnerHTML={{__html: cleanHtml(note)}}></div>;
        if(note.voice_url) {
	    content = (
                <audio controls>
	          <source src={note.voice_url} type={note.voice_url_file_type} />
	          <p>Sorry, it looks like we're unable to play this file for you. Please download it <a href="<%= message.voice_url %>">here</a>.</p>
	        </audio>
            );
        }
        
        return (
            <div className="request-message--body">
              { metaData }
              <div className="request-message--message-content" >{ content }</div>
            </div>
        );
    }
}
class NoteFooter extends React.Component {
    render() {
        let note = this.props.note;

        if(note.type  == 'message-from-third-party') {
	    return (
                <div className="padding-20">
		  {/* <button className="btn show-popup-email-full-content" data-message-key="<%= message.key %>">View full email</button> */}
		  <a target="_blank" className="btn send-email-btn"
		     href={"/admin/request/email/popup/" + note.request + "?message=" + note.key}
		     onClick={() => { (new ADMIN).EmailPopup(note.request, null, note.key); return false; }}>
		    <i className="fh-icon-mail" style={style.emailIcon}></i>
		    Reply
		  </a>
		</div>);
        }
        else if (note.type === 'message-from-client' && window.pageVariables.is_god) {
	    return (
                <div style={style.ccNote}>
		  Gods Only: <a href={"/god/request/message/edit?message_key=" + note.key}>Remove CC Info</a>
		</div>
            );
        }

        return null;
    }
}

class SingleNotes extends React.Component {
    render() {
        let note = this.props.note;
        return (
            <div className={"admin-request-" + note.type + " request-message message-in-list cf"}>
              <NoteHeader note={note}/>
              <NoteContent note={note} />
              <NoteFooter note={note} />              
            </div>
            
        );
    }
}

class RequestNotes extends React.Component {
    constructor(props) {
    	super(props);
        console.log("RequestNotesProps: %o", props);
    	this.state = {
            notes: [],
            initialLoading: true,
            nextPage: null,
            loadedAll: true,
	        requestKey: props.key || window.pageVariables.request_key,
            expand: false,
            el: null
        };
        this.loadAll = this.loadAll.bind(this);
        // Morty.setTitle("Lead Assistant Stats");
    }


    loadAll() {
        this.setState({ loadedAll: true });
        this.loadNotes(this.state.nextPage, undefined, true);
    }

    loadNotes(nextPage, pageCount, forceLoadAll) {

        let DEFAULT_PAGES = 2;
        if(pageCount === undefined)
            pageCount = 0;
        if(forceLoadAll === undefined)
            forceLoadAll = false;
        
	let url = '/admin/request/' + this.state.requestKey + '/notes/paginated';
	Morty.get(url, { next_page: nextPage }).then((response) => {
            response.notes.reverse();
            let notes = [...response.notes, ...this.state.notes];

	    this.setState({ notes: notes, initialLoading: false });

            // are there more notes?
            if(response.next_page) {
                // lets only load DEFAULT_PAGES number of pages by default
                if(true || pageCount < DEFAULT_PAGES) {
                    this.loadNotes(response.next_page, (forceLoadAll ? 0 : pageCount + 1));
                }
                else {
                    this.setState({ nextPage: response.next_page,
                                    showLoadAllButton: true });
                }
            }
            else {
                this.setState({ loadedAll: true });
            }
	});
    }
     
    componentDidMount() {
	if(this.state.requestKey) {
	    this.loadNotes(null);
	}
        this.scrollToBottom();
    }

    componentDidUpdate() {
        this.scrollToBottom();
    }

    scrollToBottom() {
        if(this.el) {
            
            function scrollParentToChild(parent, child) {
                
                // Where is the parent on page
                var parentRect = parent.getBoundingClientRect();
                // What can you see?
                var parentViewableArea = {
                    height: parent.clientHeight,
                    width: parent.clientWidth
                };
                
                // Where is the child
                var childRect = child.getBoundingClientRect();
                // Is the child viewable?
                var isViewable = (childRect.top >= parentRect.top) && (childRect.top <= parentRect.top + parentViewableArea.height);
                
                // if you can't see the child try to scroll parent
                if (!isViewable) {
                    // scroll by offset relative to parent
                    parent.scrollTop = (childRect.top + parent.scrollTop) - parentRect.top;
                }
                
                
            }
            scrollParentToChild(this.el.parentNode, this.el);
            // this.el.scrollIntoView({ behavior: 'smooth', block: "end" });
        }
        
    }

    render() {
	if(!this.state.requestKey) {
	    return <h2>Unable to load messages</h2>;
	}	
	if(this.state.initialLoading && (!this.state.notes.length)) {
	    return <Spinner text="Loading Messages" />;
	}

	let notes = this.state.notes.map((note) => <SingleNotes note={note} key={note.key} />);
        
        let s = {
            height: 700,
            overflow: "auto"
        };
        
        if(this.state.expand) {
            s = {};
        }

	return (
            <div>
	      <div style={s}>
                { this.state.loadedAll ? null : <div style={{textAlign: "center"}}><a href="javascript://" className="btn" onClick={() => { this.loadAll(); }}>Load the rest...</a></div>  }
	        {notes}
                <div ref={(el) => { this.el = el; }}  style={{ textAlign: "center", paddingTop: 16 }}>
                  <a href="javascript://" className="btn" onClick={() => this.setState({ expand: !this.state.expand })}>
                    { this.state.showAll ? <span>Collapse &uarr;</span> : <span>Expand &darr;</span> }
                  </a>
                </div>
	      </div>
            </div>
	);

    }
    
}

const style = {
    icon: { color: "#666"  },
    emailIcon: { top: 3 },
    ccNote: {
        borderTop: "solid 1px #dcdcdc",
        textAlign: "right"
    }            
    
};


export default RequestNotes;
